import script from "./EditParticipantBox.vue?vue&type=script&setup=true&lang=js"
export * from "./EditParticipantBox.vue?vue&type=script&setup=true&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./EditParticipantBox.vue?vue&type=style&index=1&id=747ee63e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2025-january\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-747ee63e"]])

export default __exports__